
const valueAp = 'Asia Pacific';
const valueAm = 'Americas';
const valueEu = 'Europe';
const valueGlobal = 'GlobalCom';

export enum Region {
  AP = 'AP',
  EU = 'EU',
  AM = 'AM',
  GOBAL = 'GLOBAL'
}

export function getName(region: Region) {
  switch(region) {
    case Region.AP: return valueAp;
    case Region.AM: return valueAm;
    case Region.EU: return valueEu;
    case Region.GOBAL: return valueGlobal;
  }
}

export function getStringValue(region: Region) {
  switch(region) {
    case Region.AP: return 'AP';
    case Region.AM: return 'AM';
    case Region.EU: return 'EU';
    case Region.GOBAL: return 'GLOBAL';
  }
}

export function getType(region: string) {
  if(region === valueAp) return Region.AP;
  if(region === valueAm) return Region.AM;
  if(region === valueEu) return Region.EU;
  if(region === valueGlobal) return Region.GOBAL;
  throw new Error(`No region with name ${region} exists.`);
}

export function getEnumValues(): Array<string> {
  return ['AP', 'EU', 'AM', 'GLOBAL'];
}

export default Region;